import { Box } from '@material-ui/core';
import {
  getMerchantById,
  Merchant,
  patchChangeAcquisitionChannelByMerchantId,
  patchChangeRegistrationFieldsByMerchantId,
} from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { MerchantRegistrationDataForm } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantRegistrationData/components/MerchantRegistrationDataForm';
import {
  MerchantRegistrationDataFormSchema,
  MerchantRegistrationDataFormType,
} from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantRegistrationData/schemas/MerchantRegistrationDataFormSchema';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface MerchantRegistrationDataEditDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  merchant: Merchant;
  showInternalData: boolean;
}
export const MerchantRegistrationDataEditDialog = ({
  opened,
  setOpened,
  toggleDialog,
  merchant,
  showInternalData,
}: MerchantRegistrationDataEditDialogProps) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getMerchantById, { merchantId: merchant.id });

  const merchantRegistrationDataDefaultValues = {
    businessName: merchant.registrationFields.businessName,
    corporateIdNumber: merchant.registrationFields.corporateIdNumber,
    postalCode: merchant.registrationFields.postalCode,
    category: merchant.registrationFields.category,
    declaredBusinessType: merchant.registrationFields.businessType.declaredBusinessType,
    amountOfEmployees: merchant.registrationFields.amountOfEmployees,
    turnover: merchant.registrationFields.turnover,
    acquisitionChannel: merchant.acquisitionChannel,
    firstName: merchant.registrationFields.fullName.firstName,
    lastName: merchant.registrationFields.fullName.lastName,
    phoneNumber: merchant.registrationFields.phoneNumber,
    email: merchant.registrationFields.email,
  };

  const onSubmitForm = async (useFormValues: MerchantRegistrationDataFormType) => {
    await request(patchChangeRegistrationFieldsByMerchantId, { ...useFormValues, id: merchant.id });
    if (useFormValues.acquisitionChannel !== merchant.acquisitionChannel) {
      await request(patchChangeAcquisitionChannelByMerchantId, {
        id: merchant.id,
        acquisitionChannel: useFormValues.acquisitionChannel,
      });
    }
    toggleDialog();
    revalidate();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'MERCHANT_CONFIGURATION'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={MerchantRegistrationDataFormSchema}
      defaultValues={merchantRegistrationDataDefaultValues}
    >
      <Box pt={2}>
        <MerchantRegistrationDataForm
          merchant={merchant}
          showInternalData={showInternalData}
          fieldVariant={FieldVariant.form}
          fullWidth
        />
      </Box>
    </EditDialogWrapper>
  );
};
